import type { InspiredGlobalStudyPlatformApiModelsSubjectsGetAssignmentResponse as Assignment } from 'applications/GSP/shared/api/gsp';

export const enum TabValue {
  Overview = 'AssignmentDetails/Overview',
  Results = 'AssignmentDetails/Results',
}

export interface AssignmentDetailsProps {
  isLoading?: boolean;
  assignment?: Assignment;
}
